module.exports = __webpack_public_path__ + "img/smoke_shop_6.6d22e406.png";